import React from 'react';
import {BaseMatchedTransaction, TxType} from "../../../model/MatchedDocument";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider} from "@mui/material";
import MyMaterialTable from "../../../components/mtable/MyMaterialTable";
import TransactionTablesComponent from "./TransactionTablesComponent";
import {creditTableRowStyle, debitTableRowStyle} from "../../theme";
import AccountCodeSelector from "../../../components/selector/AccountCodeSelector";

interface IProps {
    itemsToOverride: BaseMatchedTransaction[],
    onOverride: (accountCode: string) => any,
    onClose: () => any,
}

interface IState {
    accountCode?: string
}

export default class AccountCodeSelectionModal extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
    }

    render() {
        return <>
            <Dialog onClose={this.closeModal} open={true} fullWidth={true} maxWidth={'md'}>
                <DialogTitle>
                    Link with GL record
                </DialogTitle>
                <DialogContent dividers>
                    <AccountCodeSelector
                            label="Account code"
                            value={this.state.accountCode}
                            placeholder="Account code"
                            errorText="Account code is mandatory"
                            onChanged={code => this.setState({accountCode: code})}
                    />
                    <Divider style={{margin: "0.5rem"}}/>
                    {this.renderTxInfo()}
                </DialogContent>
                <DialogActions>
                    <Button
                            disabled={!this.state.accountCode}
                            autoFocus
                            onClick={this.doOverride} variant="contained"
                            color="primary">
                        Override
                    </Button>
                    <Button autoFocus onClick={this.closeModal} variant="contained" color="secondary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>;
    }

    private renderTxInfo() {
        return <>
            <MyMaterialTable
                    columns={[
                        TransactionTablesComponent.txDateColumn(),
                        TransactionTablesComponent.txDescriptionColumn(),
                        TransactionTablesComponent.amountColumn(),
                        TransactionTablesComponent.txTypeColumn(),
                        {
                            field: 'tx.debtorName',
                            title: 'Dbtr Name',
                        },
                        {
                            field: 'tx.creditorName',
                            title: 'Cdtr Name',
                        },
                    ]}
                    data={this.props.itemsToOverride}
                    options={{
                        header: true,
                        toolbar: false,
                        search: false,
                        sorting: false,
                        paging: false,
                        draggable: false,
                        rowStyle: row => row.tx.txType === TxType.CRDT ? creditTableRowStyle : debitTableRowStyle,
                    }}
            />
        </>
    }

    private doOverride = () => {
        this.props.onOverride(this.state.accountCode!!);
    };

    private closeModal = () => {
        this.props.onClose();
    };

}